import React, { useEffect, useState } from 'react';
import {
  DataGrid,
  Button,
  useResponsiveParams,
  Text,
  NotificationList,
} from 'quanta-ui';
import {
  faSave,
  faEnvelope,
  faSms,
  faDownload,
  faCheck,
  faSpinner,
  faExclamationTriangle,
  faShare,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useQuery, useMutation } from '@apollo/client';
import {
  CUSTOMER_DROPDOWN_DETAILS,
  GET_CUSTOMER_TYPE_DOMAIN,
  GET_FIELDUSER_LIST,
  // GET_PCV_POLICY_VAR_DETAILS,
  GET_MISCD_POLICY_VAR_DETAILS,
  INTERMEDIARY_LIST,
  // SAVE_QUOTE_PCV,
  SAVE_QUOTE_MISCD,
  // SEND_QUOTE_EMAIL_PCV_ALERT,
  SEND_QUOTE_EMAIL_MISCD_ALERT,
  // SEND_QUOTE_PDF_PCV,
  SEND_QUOTE_PDF_MISCD,
  // SEND_QUOTE_SMS_PCV_ALERT,
  SEND_QUOTE_SMS_MISCD_ALERT,
} from '../queries';
import {Loading} from 'quanta-flows/modules/layout';
import {Error} from 'quanta-flows/modules/layout';
import ModalSaveQuote from './modal-save-quote';
//import ModalSendEmail from '../../../../common/common-modals/modal-send-email';
//import { ModalSendEmail } from 'quanta-flows/modules/common/modals';
import {ModalSendSmsPCV} from 'quanta-flows/modules/quote/motor';
import { ModalSendSms } from 'quanta-flows/modules/common/modals';
import { ModalSendEmail } from 'quanta-flows/modules/common/modals';
//import ModalSendSms from '../../../../common/common-modals/modal-send-sms';
import  {ModalSendEmailPCV } from 'quanta-flows/modules/quote/motor';
//import useMutationQuery from '../../../../../lib/graphql/useMutationQuery';
import { useMutationQuery } from 'quanta-flows';
// import { updateQuotationDetails } from '../_graphql/state';
import { updateQuotationDetails } from 'quanta-flows/modules/quote/motor/state';
import DownloadAndShare from './download-and-share';
//import {useFetchQuery} from '../../../../../lib/graphql/useFetchQuery';
import { useFetchQuery } from 'quanta-flows';
import GetFieldUserName from './get-field-userName';
//import TransactionComponent from '../../../../../lib/security/transaction_component';
// import { TransactionComponent } from 'quanta-flows';

export default function QuoteSummaryDetails({
  productCode,
  productName,
  lobName,
  lobCode,
  quoteNumber,
  ...props
}) {
  const fetchQuery = useFetchQuery();
  const [alerts, setAlerts] = useState([]);
  const [loadingFieldUserList, setLoadingFieldUserList] =
    useState(false);
  const [errorFieldUserList, setErrorFieldUserList] = useState(null);
  const [fieldUserList, setFieldUserList] = useState(null);
  const [showEmail, setShowEmail] = useState(false);
  const [showSms, setShowSms] = useState(false);
  const [showDownloadAndShare, setShowDownloadAndShare] =
    useState(false);
  const [saveQuoteDisplay, setSaveQuoteDisplay] = useState(false);
  const [loadingDownload, setLoadingDownload] = useState(false);
  const mutateQuery = useMutationQuery();

  const [customerNameQuoteSaved, setCustomerNameQuoteSaved] =
    useState(null);

  const {
    loading,
    error,
    data: state,
  } = useQuery(GET_MISCD_POLICY_VAR_DETAILS, {
    onCompleted: async (data) => {
      const { selectedIntermediary, motorQuote } = data;
      try {
        const getFieldUserListQuery = fetchQuery({
          query: GET_FIELDUSER_LIST,
          variables: {
            input: {
              intermediaryCode:
                motorQuote?.intermediaryDetails?.code ||
                selectedIntermediary?.intermediaryCode,
              officeId:
                motorQuote?.intermediaryDetails?.location ||
                selectedIntermediary?.branchOfficeCode,
            },
          },
        });
        setLoadingFieldUserList(true);
        const { data: dataFieldUserList } =
          await getFieldUserListQuery;
        setLoadingFieldUserList(false);
        setFieldUserList(dataFieldUserList?.getFiledUserByIMID);
      } catch (error) {
        setErrorFieldUserList(error?.message);
        setLoadingFieldUserList(false);
      }
    },
  });

  const {
    loading: intermediaryListLoading,
    error: intermediaryListError,
    data: intermediaryListData,
  } = useQuery(INTERMEDIARY_LIST);

  const {
    loading: loading_cust_type_domain,
    error: error_cust_type_domain,
    data: data_cust_type_domain,
  } = useQuery(GET_CUSTOMER_TYPE_DOMAIN, {
    fetchPolicy: 'cache-first',
  });

  const {
    loading_customer_dropdown_details,
    error_customer_dropdown_details,
    data: dropDownDetails,
  } = useQuery(CUSTOMER_DROPDOWN_DETAILS, {
    fetchPolicy: 'cache-first',
  });

  const repeatForMobile = 2,
    repeatForDesktop = 1,
    repeatForIpad = 4;

  let repeat = useResponsiveParams({
    for_mobile: repeatForMobile,
    for_desktop: repeatForDesktop,
    for_iPad: repeatForIpad,
  });

  const getGraphQLErrorMessage = (error) => {
    return error.graphQLErrors.length > 0
      ? error.graphQLErrors.map((gerr) =>
          gerr && gerr.message
            ? gerr.message
            : 'Internal Error Occurred',
        )[0]
      : error.message
      ? error.message
      : 'Internal Error Occurred';
  };

  const [
    doSaveQuotePCV,
    { loading: saveLoading, error: saveError },
  ] = useMutation(SAVE_QUOTE_MISCD, {
    onCompleted: (data) => {
      props?.forwardedCoversFormRef?.current?.setFieldValue(
        `isQuoteSaved`,
        true,
      );
      props?.forwardedCoversFormRef?.current?.setFieldValue(
        `isQuoteSaving`,
        false,
      );
      updateQuotationDetails(
        data.saveQuoteTW.quoteNumber,
        data.saveQuoteTW.status,
        data.saveQuoteTW.quoteCreationDate,
        props?.forwardedCoversFormRef?.current?.values?.rawRiskData?.map(
          (riskType) => {
            return {
              ...riskType,
              covers: riskType?.covers
                ?.filter(
                  (cover) =>
                    props?.forwardedCoversFormRef?.current?.values
                      ?.addOnCovers[cover?.name]?.selected,
                )
                ?.map((cover) => {
                  return {
                    ...cover,
                    selected: props?.forwardedCoversFormRef?.current
                      ?.values?.addOnCovers[cover?.name]?.selected
                      ? true
                      : cover?.selected,
                    attributes: cover?.attributes?.map(
                      (attribute) => {
                        return {
                          ...attribute,
                          value:
                            props?.forwardedCoversFormRef?.current
                              ?.values?.addOnCovers[cover?.name]
                              ?.attributes[attribute?.name] !==
                              null &&
                            props?.forwardedCoversFormRef?.current
                              ?.values?.addOnCovers[cover?.name]
                              ?.attributes[attribute?.name] !==
                              undefined
                              ? props?.forwardedCoversFormRef?.current
                                  ?.values?.addOnCovers[cover?.name]
                                  ?.attributes[attribute?.name]
                              : attribute?.value,
                        };
                      },
                    ),
                  };
                }),
            };
          },
        ),
      );
      setAlerts([
        {
          header: 'Quote Saved Successfully',
          id: Date.now(),
          content: (
            <div className="flex flex-col w-full h-full">
              <Text type="normal">
                <FontAwesomeIcon
                  icon={faCheck}
                  className="text-success"
                />{' '}
                Quote Saved successfully for{' '}
                <span className="font-bold">
                  {customerNameQuoteSaved}
                </span>
              </Text>
              <Text type="normal">
                <FontAwesomeIcon
                  icon={faCheck}
                  className="text-success"
                />{' '}
                Quotation Number: {data.saveQuoteTW.quoteNumber}
              </Text>
            </div>
          ),
          type: 'success',
          timeout: null,
          disableClose: false,
        },
      ]);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },

    onError: (error) => {
      props?.forwardedCoversFormRef?.current?.setFieldValue(
        `isQuoteSaving`,
        false,
      );
      props?.forwardedCoversFormRef?.current?.setFieldValue(
        `isQuoteSaved`,
        false,
      );
      setAlerts([
        ...alerts,
        {
          header: 'Error',
          id: Date.now(),
          content: (
            <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
              {getGraphQLErrorMessage(error)}
            </div>
          ),
          type: 'error',
          timeout: null,
          disableClose: false,
        },
      ]);
    },
  });

  useEffect(() => {
    if (saveLoading) {
      props?.forwardedCoversFormRef?.current?.setFieldValue(
        `isQuoteSaving`,
        true,
      );
    }
  }, [saveLoading]);

  if (
    loading ||
    loading_cust_type_domain ||
    loading_customer_dropdown_details ||
    intermediaryListLoading ||
    loadingFieldUserList
  )
    return <Loading />;
  if (
    error ||
    error_cust_type_domain ||
    error_customer_dropdown_details ||
    intermediaryListError ||
    errorFieldUserList
  )
    return (
      <Error
        error={
          error ||
          error_cust_type_domain ||
          error_customer_dropdown_details ||
          intermediaryListError ||
          errorFieldUserList
        }
      />
    );

  const { motorQuote, selectedIntermediary } = state;
  const { myIntermediaries } = intermediaryListData;

  const getBase64VarForPCV = () => {
    let riskInput = [];
    props?.forwardedCoversFormRef?.current?.values?.rawRiskData?.forEach(
      (r) => {
        let covers = [];
        r.covers
          .filter(
            (c) =>
              props?.forwardedCoversFormRef?.current?.values[
                `addOnCovers`
              ][c?.name]?.selected,
          )
          .forEach((c) => {
            const { selected, attributes, ...rest } = c;
            let attributesArr = [];
            c?.attributes?.forEach((attribute) => {
              attributesArr.push({
                ...attribute,
                value: attribute?.showOnScreen
                  ? `${
                      props?.forwardedCoversFormRef?.current?.values[
                        `addOnCovers`
                      ][`${c?.name}`][`attributes`][
                        `${attribute?.name}`
                      ]
                    }`
                  : `${attribute?.defaultValue}`,
              });
            });
            covers.push({
              ...rest,
              attributes: [...attributesArr],
            });
          });
        if (covers?.length !== 0) {
          riskInput.push({
            riskType: r?.riskType,
            covers,
          });
        }
      },
    );
    return {
      input: {
        businessType: motorQuote?.businessType,
        intermediary: {
          intermediaryCode: motorQuote?.intermediaryDetails?.code ||
            selectedIntermediary?.intermediaryCode ,
          intermediaryName: motorQuote?.intermediaryDetails?.code ||
          selectedIntermediary?.intermediaryCode ,
          locationCode:motorQuote?.intermediaryDetails?.location
            ?motorQuote?.intermediaryDetails?.location
             :selectedIntermediary?.branchOfficeCode,
          fieldUserCode:
            selectedIntermediary?.fieldUserCode ||
            motorQuote?.intermediaryDetails?.fieldUserCode,
        },
        customer: {
          id: motorQuote?.customer?.id
            ? motorQuote?.customer?.id
            : motorQuote?.customer?.cust_number,
          customerType: motorQuote?.customer?.customerType
            ? motorQuote?.customer?.customerType
            : motorQuote?.customer?.cust_type?.code,
          title: motorQuote?.customer?.title
            ? motorQuote?.customer?.title
            : motorQuote?.customer?.indv_detail?.title?.code,
          firstName: motorQuote?.customer?.firstName
            ? motorQuote?.customer?.firstName
            : motorQuote?.customer?.indv_detail?.first_name,
          middleName: motorQuote?.customer?.middleName
            ? motorQuote?.customer?.middleName
            : motorQuote?.customer?.indv_detail?.middle_name,
          lastName: motorQuote?.customer?.lastName
            ? motorQuote?.customer?.lastName
            : motorQuote?.customer?.indv_detail?.surname,
          fullName: motorQuote?.customer?.fullName
            ? motorQuote?.customer?.fullName
            : motorQuote?.customer?.indv_detail?.full_name,
          emailID: motorQuote?.customer?.emailID
            ? motorQuote?.customer?.emailID
            : motorQuote?.customer?.contact?.email,
          mobileNo: motorQuote?.customer?.mobileNo
            ? motorQuote?.customer?.mobileNo
            : motorQuote?.customer?.contact?.mobile,
          proposerDOB: motorQuote?.customer?.proposerDOB
            ? motorQuote?.customer?.proposerDOB
            : motorQuote?.customer?.indv_detail?.date_of_birth,
          orgName: motorQuote?.customer?.orgName
            ? motorQuote?.customer?.orgName
            : motorQuote?.customer?.org_detail?.org_name,
          orgType: motorQuote?.customer?.orgType
            ? motorQuote?.customer?.orgType
            : motorQuote?.customer?.org_detail?.org_type?.code,
          contactName: motorQuote?.customer?.contactName
            ? motorQuote?.customer?.contactName
            : motorQuote?.customer?.org_detail?.contact_name,
        },
        lob: lobCode,
        product: motorQuote?.productCode,
        quoteCreationDate : motorQuote?.quoteCreationDate,
        productType: motorQuote?.productType,
        location: {
          pinCode: motorQuote?.pincode,
          state: motorQuote?.state,
        },
        vehicleDetails: {
          make: {
            code: motorQuote?.make?.code,
            value: motorQuote?.make?.value,
          },
          model: {
            code: motorQuote?.model?.code,
            value: motorQuote?.model?.value,
          },
          variant: {
            code: motorQuote?.variant?.code,
            value: motorQuote?.variant?.value,
          },
          engineNumber: motorQuote?.engineNo,
          chasisNumber: motorQuote?.chasisNo,
          registrationNumber: motorQuote?.regNo,
          manufactureYear: motorQuote?.yearOfManufacture,
          regPurchaseDate: motorQuote?.dateOfReg,
          fuelType: motorQuote?.fuelType,
          seatingCapacity: motorQuote?.seatingCapacity,
          cubicCapacity: motorQuote?.cubeCapacity,
          vehicleAge: motorQuote?.premiumData?.vehicleAge,
        },
        rtoDetails: {
          rtoAuthCode: motorQuote?.rtoAuthorityCode,
          rtoLocCode: motorQuote?.rtoLocationCode,
          rtoLocDesc: motorQuote?.rtoLocationDesc,
        },
        isPreviousPolicy:
          motorQuote?.anyPreviousPolicyforVehicleTaken === 'Yes'
            ? true
            : false,
        previousPolicy: {
          coverType:
            motorQuote?.anyPreviousPolicyforVehicleTaken === 'Yes'
              ? motorQuote?.policyCoverType
              : '',
          policyTenure:
            motorQuote?.anyPreviousPolicyforVehicleTaken === 'Yes'
              ? motorQuote?.policyTenure
              : '',
          insurerName:
            motorQuote?.anyPreviousPolicyforVehicleTaken === 'Yes'
              ? motorQuote?.prevInsurance?.insurerName
              : '',
          policyNumber:
            motorQuote?.anyPreviousPolicyforVehicleTaken === 'Yes'
              ? motorQuote?.prevInsurance?.policyNumber
              : '',
          startDate:
            motorQuote?.anyPreviousPolicyforVehicleTaken === 'Yes'
              ? motorQuote?.policyStartDate
              : '',
          expiryDate:
            motorQuote?.anyPreviousPolicyforVehicleTaken === 'Yes'
              ? motorQuote?.policyExpiryDate
              : '',
        },
        previousClaims: {
          totalClaimCount:
            motorQuote?.anyPreviousPolicyforVehicleTaken === 'Yes' &&
            motorQuote?.policyTenureValue
              ?.toLowerCase()
              ?.trim()
              ?.search('annual') !== -1
              ? motorQuote?.totalClaimCount
              : '',
          claimsInYear1:
            motorQuote?.anyPreviousPolicyforVehicleTaken === 'Yes' &&
            motorQuote?.policyTenureValue
              ?.toLowerCase()
              ?.trim()
              ?.search('long term') !== -1
              ? motorQuote?.noOfClaimsOneYear
              : '',
          claimsInYear2:
            motorQuote?.anyPreviousPolicyforVehicleTaken === 'Yes' &&
            motorQuote?.policyTenureValue
              ?.toLowerCase()
              ?.trim()
              ?.search('long term') !== -1
              ? motorQuote?.noOfClaimsTwoYears
              : '',
          claimsInYear3:
            motorQuote?.anyPreviousPolicyforVehicleTaken === 'Yes' &&
            motorQuote?.policyTenureValue
              ?.toLowerCase()
              ?.trim()
              ?.search('long term') !== -1
              ? motorQuote?.noOfClaimsThreeYears
              : '',
          prevNCBSlab:
            motorQuote?.anyPreviousPolicyforVehicleTaken === 'Yes' &&
            motorQuote?.previousYearNCBSlab
              ? motorQuote?.previousYearNCBSlab
              : '',
          totalClaimAmount:
            motorQuote?.anyPreviousPolicyforVehicleTaken === 'Yes' &&
            motorQuote?.totalClaimAmount
              ? parseFloat(motorQuote?.totalClaimAmount)
              : null,
          claimFreeYear: motorQuote?.premiumData?.claimFreeYear,
        },
        financerName: motorQuote?.financerName,
        insuredDeclaredValue: {
          suggestedIDV: motorQuote?.suggestedIDV,
          firstYearIDV: motorQuote?.changedIDV,
        },
        irf1: motorQuote?.adjustmentIRF,
        creditScoreDetials: {
          discountOpted:
            motorQuote?.getAdditionalCreditScore === 'Yes'
              ? true
              : false,
          idProofType: motorQuote?.idProofType,
          idProofNumber: motorQuote?.idProofNumber,
          creditScore: motorQuote?.premiumData?.creditScore
            ? parseFloat(motorQuote?.premiumData?.creditScore)
            : null,
        },
        coverType: '',
        tenure:
          props?.forwardedCoversFormRef?.current?.values?.tenure,
        riskCovers: riskInput,
        premiumBreakup: {
          idvYear1: parseFloat(motorQuote?.premiumData?.idv1),
          idvYear2: parseFloat(motorQuote?.premiumData?.idv2),
          idvYear3: parseFloat(motorQuote?.premiumData?.idv3),
          netODPremium: parseFloat(
            motorQuote?.premiumData?.netODPremium,
          ),
          netTPPremium: parseFloat(
            motorQuote?.premiumData?.netTPPremium,
          ),
          loadingDiscount: parseFloat(
            motorQuote?.premiumData?.loadingDiscount,
          ),
          netPremium: parseFloat(motorQuote?.premiumData?.netPremium),
          gst: parseFloat(motorQuote?.premiumData?.gst),
          stampDuty: parseFloat(motorQuote?.premiumData?.stampDuty),
          totalPremium: parseFloat(
            motorQuote?.premiumData?.totalPremium,
          ),
          loading: motorQuote?.premiumData?.loading
            ? motorQuote?.premiumData?.loading
            : [],
          discount: motorQuote?.premiumData?.discount
            ? motorQuote?.premiumData?.discount
            : [],
            NCB:parseFloat(motorQuote?.premiumData?.NCB),
        },
        policy: {
          startDate: motorQuote?.policy?.startDate,
          expiryDate: motorQuote?.policy?.expiryDate,
        },
        voluntaryDeductibleAmt: parseFloat(
          motorQuote?.voluntaryDeductibleAmount,
        ),
        QuotationRecordNo: motorQuote?.premiumData?.QuotationRecordNo
      },
      quoteNumber: motorQuote?.quotationNo,
    };
  };

  const getIntermediaryName = (code) => {
    return myIntermediaries
      ? myIntermediaries?.find(
          (intermediary) => intermediary?.intermediaryCode === code,
        )?.intermediaryName
      : code;
  };

  const getBusinessLocation = (intermediarycode, locationCode) => {
    return myIntermediaries && intermediarycode && locationCode
      ? myIntermediaries?.find(
          (intermediary) =>
            intermediary?.intermediaryCode === intermediarycode,
        )
        ? myIntermediaries
            ?.find(
              (intermediary) =>
                intermediary?.intermediaryCode === intermediarycode,
            )
            ?.businessLocations.find(
              (location) => location?.code === locationCode,
            )?.name
        : locationCode
      : '';
  };
 

  let dataforDesktopView = [
    motorQuote?.proposalNumber
      ? {
          label: 'Proposal Number',
          text: motorQuote?.proposalNumber,
        }
      : null,
    motorQuote?.quotationNo
      ? {
          label: 'Quotation No',
          text: motorQuote?.quotationNo,
        }
      : null,
    motorQuote?.productVariant
      ? {
          label: 'Product Variant',
          text: motorQuote?.productVariant,
        }
      : null,
    motorQuote?.businessType
      ? {
          label: 'Business Type',
          text: 
          motorQuote?.productType?.toString()==='Kotak Car Secure-Used Car'
         ? 'Used Car'
         :motorQuote?.businessType,
        }
      : null,
    motorQuote?.intermediaryDetails?.code ||
    selectedIntermediary?.intermediaryCode ||
    selectedIntermediary?.intermediaryName
      ? {
          label: 'Partner',
          text:
            motorQuote?.intermediaryDetails?.code ||
            selectedIntermediary?.intermediaryCode
              ?
              `${getIntermediaryName(
                motorQuote?.intermediaryDetails?.code ||
                selectedIntermediary?.intermediaryCode,
              )} (${`${motorQuote?.intermediaryDetails?.code ||
              selectedIntermediary?.intermediaryCode
              }`})`
             
              : selectedIntermediary?.intermediaryName,
        }
      : undefined,
    motorQuote?.intermediaryDetails?.location ||
    selectedIntermediary?.branchOfficeCode ||
    selectedIntermediary?.branchOfficeName
      ? {
          label: 'Branch Office',
          text:
            motorQuote?.intermediaryDetails?.location ||
            selectedIntermediary?.branchOfficeCode
              ? getBusinessLocation(
                  motorQuote?.intermediaryDetails?.code ||
                    selectedIntermediary?.intermediaryCode,
                  motorQuote?.intermediaryDetails?.location ||
                    selectedIntermediary?.branchOfficeCode,
                )
              : selectedIntermediary?.branchOfficeName,
        }
      : undefined,
    motorQuote?.intermediaryDetails?.fieldUserCode ||
    selectedIntermediary?.fieldUserCode ||
    selectedIntermediary?.fieldUserName
      ? {
          label: 'Field User',
          text:
            motorQuote?.intermediaryDetails &&
            motorQuote?.intermediaryDetails?.fieldUserCode &&
            motorQuote?.intermediaryDetails?.fieldUserCode !== '' ? (
              <GetFieldUserName
                {...{
                  code:
                    motorQuote?.intermediaryDetails?.fieldUserCode ||
                    selectedIntermediary?.fieldUserCode,
                }}
              />
            ) : motorQuote?.intermediaryDetails.code !== '' &&
              motorQuote?.intermediaryDetails?.fieldUserCode ===
                '' ? (
              ''
            ) : (
              selectedIntermediary.fieldUserName
            ),
        }
      : undefined,
      motorQuote?.policy?.startDate
      ? {
        label: 'Policy Start Date',
        text: motorQuote?.policy?.startDate,
      }
      : null,
    motorQuote?.policy?.expiryDate
      ? {
        label: 'Policy End Date',
        text: motorQuote?.policy?.expiryDate,
      }
      : null,
    motorQuote?.premiumData?.NCB || motorQuote?.policy?.ncb
      ? {
        label: 'NCB %',
        text: motorQuote?.premiumData?.NCB
          || motorQuote?.policy?.ncb,
      } : null,
    {
      text: (
        // <TransactionComponent>
        <Button
          disabled={
            motorQuote?.quotationNo !== '' ||
            motorQuote?.isPremiumCalculating !== false ||
            saveLoading
          }
          size="medium"
          className="mt-2 w-full h-10"
          onClick={(_) => setSaveQuoteDisplay(true)}
          flat={true}
          iconPre={
            saveLoading ? (
              <FontAwesomeIcon icon={faSpinner} spin={true} />
            ) : saveError ? (
              <FontAwesomeIcon icon={faExclamationTriangle} />
            ) : (
              <FontAwesomeIcon icon={faSave} />
            )
          }
        >
          {saveLoading ? `Saving...` : `Save Quote`}
        </Button>
      //  </TransactionComponent>
      ),
    },
    {
      text: (
        <Button
          disabled={motorQuote.quotationNo === '' ? true : false||loadingDownload}
          size="medium"
          className="mt-2 w-full h-10"
          flat={true}
          iconPre={<FontAwesomeIcon icon={faEnvelope} />}
          onClick={(e) => setShowEmail(true)}
        >
          Email Quote
        </Button>
      ),
    },
    {
      text: (
        <Button
          disabled={motorQuote.quotationNo === '' ? true : false||loadingDownload}
          size="medium"
          className="mt-2 w-full h-10"
          flat={true}
          iconPre={<FontAwesomeIcon icon={faSms} />}
          onClick={(e) => setShowSms(true)}
        >
          Message Quote
        </Button>
      ),
    },
    {
      text: (
        <Button
          disabled={
            motorQuote.quotationNo === '' || loadingDownload
              ? true
              : false
          }
          size="medium"
          className="mt-2 w-full h-10"
          flat={true}
          iconPre={
            <FontAwesomeIcon
              icon={loadingDownload ? faSpinner : faDownload}
              spin={loadingDownload}
            />
          }
          onClick={async (_) => {
            try {
              setLoadingDownload(true);
              let quotePDFBase64String = mutateQuery({
                mutation: SEND_QUOTE_PDF_MISCD,
                variables: getBase64VarForPCV(motorQuote),
              });
              let { data: dataBase64String } =
                await quotePDFBase64String;
              const { sendQuotePDFTW } = dataBase64String;
              const { base64Pdf: downloadBase64String } =
                sendQuotePDFTW;
              setLoadingDownload(false);

              let byteCharacters = atob(
                downloadBase64String.toString(),
              );
              let byteNumbers = new Array(byteCharacters.length);
              for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
              }
              let byteArray = new Uint8Array(byteNumbers);
              let file = new Blob([byteArray], {
                type: 'application/pdf;base64',
              });
              let fileURL = URL.createObjectURL(file);
              // window.open(fileURL);
              const downloadLink = document.createElement('a');
              const fileName = `${productName ||  motorQuote?.productVariant
              }-${motorQuote?.quotationNo}.pdf`;
              downloadLink.href = fileURL;
              downloadLink.download = fileName;
              downloadLink.click();
              window.URL.revokeObjectURL(fileURL);
            } catch (error) {
              setAlerts([
                {
                  id: Date.now(),
                  content: (
                    <div className="flex flex-col w-full h-full">
                      <Text type="normal">{error.message}</Text>
                    </div>
                  ),
                  type: 'error',
                  timeout: null,
                  disableClose: false,
                },
              ]);
              setLoadingDownload(false);
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }
          }}
        >
          {loadingDownload ? `Downloading...` : `Download Quote`}
        </Button>
      ),
    },
  ].filter((d) => d);

  let dataforiPadView = [
    {
      label: 'Product Type',
      text: motorQuote?.productType,
    },
    {
      label: 'Business Type',
      text: motorQuote?.businessType,
      colSpan: motorQuote?.quotationNo ? 1 : 2,
    },
    motorQuote?.quotationNo
      ? {
          label: 'Quotation No',
          text: motorQuote?.quotationNo,
        }
      : null,
    {
      colSpan: 1,
      text: (
        <Text className="flex justify-end">
          {/* <TransactionComponent> */}
          <Button
            flat
            type={'button'}
            size="medium"
            onClick={() => {
              if (
                motorQuote?.isPremiumCalculating === false &&
                !saveLoading
              ) {
                if (!motorQuote?.quotationNo) {
                  setSaveQuoteDisplay(true);
                } else {
                  setShowDownloadAndShare(true);
                }
              }
            }}
            className={`w-48 mt-2 ${
              motorQuote?.isPremiumCalculating !== false ||
              saveLoading
                ? 'border-neutral-darker text-neutral-darker hover:bg-neutral-darker focus:outline-none'
                : ''
            }`}
            iconPre={
              saveLoading ? (
                <FontAwesomeIcon
                  icon={faSpinner}
                  spin={true}
                  size="sm"
                  className="mr-1"
                />
              ) : saveError ? (
                <FontAwesomeIcon
                  icon={faExclamationTriangle}
                  size="sm"
                  className="mr-1"
                />
              ) : motorQuote?.quotationNo ? (
                <FontAwesomeIcon
                  icon={faShare}
                  size="sm"
                  className="mr-1"
                />
              ) : (
                <FontAwesomeIcon
                  icon={faSave}
                  size="sm"
                  className="mr-1"
                />
              )
            }
          >
            {motorQuote?.quotationNo
              ? `Download & Share`
              : saveLoading
              ? `Saving...`
              : `Save Quote`}
          </Button>
          {/* </TransactionComponent> */}
        </Text>
      ),
    },
  ].filter((d) => d);

  let dataforMobileView = [
    {
      label: 'Product & Business Type',
      text:
        motorQuote?.productVariant &&
        motorQuote?.businessType ? (
          <div className="flex flex-col">
            <span>{motorQuote?.productVariant}</span>
            <span>{motorQuote?.businessType}</span>
          </div>
        ) : (
          <Text className="text-neutral-darker">Not Captured</Text>
        ),
    },
    {
      colSpan: 1,
      text: (
        <Text className="flex justify-end">
          {/* <TransactionComponent> */}
          <Button
            flat
            type={'button'}
            size="small"
            onClick={() => {
              if (
                motorQuote?.isPremiumCalculating === false &&
                !saveLoading
              ) {
                if (!motorQuote?.quotationNo) {
                  setSaveQuoteDisplay(true);
                } else {
                  setShowDownloadAndShare(true);
                }
              }
            }}
            className={`w-40 mt-2 ${
              motorQuote?.isPremiumCalculating !== false ||
              saveLoading
                ? 'border-neutral-darker text-neutral-darker hover:bg-neutral-darker focus:outline-none'
                : ''
            }`}
            iconPre={
              saveLoading ? (
                <FontAwesomeIcon
                  icon={faSpinner}
                  spin={true}
                  size="sm"
                  className="mr-1"
                />
              ) : saveError ? (
                <FontAwesomeIcon
                  icon={faExclamationTriangle}
                  size="sm"
                  className="mr-1"
                />
              ) : motorQuote?.quotationNo ? (
                <FontAwesomeIcon
                  icon={faShare}
                  size="sm"
                  className="mr-1"
                />
              ) : (
                <FontAwesomeIcon
                  icon={faSave}
                  size="sm"
                  className="mr-1"
                />
              )
            }
          >
            {motorQuote?.quotationNo
              ? `Download & Share`
              : saveLoading
              ? `Saving...`
              : `Save Quote`}
          </Button>
          {/* </TransactionComponent> */}
        </Text>
      ),
    },
  ].filter((d) => d);

  return (
    <>
      <div>
        <DataGrid
          data={
            repeat === repeatForDesktop
              ? dataforDesktopView
              : repeat === repeatForMobile
              ? dataforMobileView
              : dataforiPadView
          }
          repeat={repeat}
          textType="normal"
          className="w-full"
          nullData={() => {
            return (
              <Text type="normal" severity="neutral-darker">
                Not Captured
              </Text>
            );
          }}
        />
      </div>
      <div>
        <ModalSaveQuote
          {...{
            saveQuoteDisplay,
            setSaveQuoteDisplay,
            setCustomerNameQuoteSaved,
            doSaveQuotePCV,
            product_code: productCode,
            lob_code: lobCode,
            lob_name: lobName,
            product_name: productName,
            quote_number: quoteNumber,
            motorQuote,
            forwardedCoversFormRef: props?.forwardedCoversFormRef,
            data_cust_type_domain,
            dropDownDetails,
            selectedIntermediary,
          }}
        />
      </div>
      <NotificationList
        {...{
          items: alerts,
          resetAlerts: (idx) => {
            const alertToBeRemovedPos = alerts.findIndex(
              (a) => a.id === idx,
            );
            setAlerts([
              ...alerts.slice(0, alertToBeRemovedPos),
              ...alerts.slice(alertToBeRemovedPos + 1, alerts.length),
            ]);
          },
        }}
      />
      <ModalSendEmail
        {...{
          showEmail,
          setShowEmail,
          initialEmail: motorQuote?.customer?.emailID
            ? motorQuote?.customer?.emailID
            : motorQuote?.customer?.contact?.email,
          SEND_EMAIL_QUERY: SEND_QUOTE_EMAIL_MISCD_ALERT,
          getPayLoad: (email, ccEmailIds) => {
            return {
              ...getBase64VarForPCV(),
              email,
              ccEmailIds,
            };
          },
        }}
      />
      <ModalSendSms
        {...{
          showSms,
          setShowSms,
          initialMobile: motorQuote?.customer?.mobileNo
            ? motorQuote?.customer?.mobileNo
            : motorQuote?.customer?.contact?.mobile,
          SEND_SMS_QUERY: SEND_QUOTE_SMS_MISCD_ALERT,
          getPayLoad: (
            mobile,
            alternateMobileNos,
            whatsappNo,
            modes,
          ) => {
            return {
              ...getBase64VarForPCV(),
              mobile,
              alternateMobileNos,
              whatsappNo,
              modes,
            };
          },
        }}
      />
      <DownloadAndShare
        {...{
          showDownloadAndShare,
          setShowDownloadAndShare,
          TWQuoteInput: getBase64VarForPCV(),
          motorQuote: motorQuote,
          product_code: productCode,
          lob_code: lobCode,
          lob_name: lobName,
          quote_number: quoteNumber,
          product_name: productName,
          forwardedCoversFormRef: props?.forwardedCoversFormRef,
        }}
      />
    </>
  );
}
